module.exports = "/_next/static/images/know-transfez-works-9f743b92f2115d030c8bbca5df9f75ef.svg";